import React, { useRef } from 'react';
import { Link } from 'react-router-dom'
import dateFormat from 'dateformat'

import SearchBox from '../../components/psc/lib/SearchBox'
import GncDataTable from '../../components/psc/lib/GncDataTable'
import useTableSlots from '../../hooks/useTableSlots'
import useBrowserTabTitle from '../../hooks/useBrowserTabTitle'
import useConfiguration from '../../hooks/useConfiguration'

const OAuthClients = () => {
    useBrowserTabTitle('OAuth Clients')

    const { siteBaseUrl } = useConfiguration()

    const table = useRef(null)
    const urlGetData = '/v0/oauth_clients'
    const localStorageOrderKey = 'tblOAuthClientsOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' },
        { data: 'client_id' },
        { data: 'expires_at' },
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
            <th>Client ID</th>
            <th>Expiration</th>
        </tr>
    )

    const expirationSlot = (data, type, row) => {
        if (data === null) return ''
        if (type === 'sort') return dateFormat(data, 'yyyy-mm-dd')
        if (type !== 'display') return dateFormat(data, 'dd-mm-yyyy')
        const expires = new Date(data)
        const now = new Date()
        const diffDays = (expires - now) / (1000 * 60 * 60 * 24)
        const isUrgent = diffDays < 10
        return (
            <span style={{whiteSpace: 'nowrap', color: isUrgent ? 'red' : undefined}}>
                {dateFormat(data, 'dd-mm-yyyy')}
            </span>
        )
    }

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/cadm/oauth_clients/${row.id}`),
        2: expirationSlot,
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h2>OAuth Clients</h2>

                            <div className="pre-table-buttons">
                                <Link to="/cadm/oauth_clients/new" className="btn btn-mr btn-primary" type="button">New OAuth Client</Link>
                            </div>

                            <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                OAuth clients are used for API integrations and third-party applications.
                            </div>

                            <div key="newText2" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                Documentation for the API is available at{' '}
                                <a href={`https://api.${siteBaseUrl}/docs/`} target="_blank" rel="noopener noreferrer">
                                    {`https://api.${siteBaseUrl}/docs/`}
                                </a>
                                .
                            </div>

                            <div key="newText3" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                In order to use an OAuth client in the documentation section, you need to 
                                specify one Redirect URI as: <strong>https://api.{siteBaseUrl}/docs/oauth2-redirect.html</strong>
                                .
                            </div>
                        </div>
                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                tableRef={table}
                                dataUrl={urlGetData}
                                defaultOrder={defaultOrder}
                                localStorageOrderKey={localStorageOrderKey}
                                columns={columns}
                                tableSlots={tableSlots}
                                tableHead={tableHead}
                                tableFoot={tableHead}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default OAuthClients
